<script setup lang="ts">
import { computed } from 'vue'
import ResourceCard from '@/resources/ResourceCard.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'

// Gives Home's resource card events their place in the list without changing the shared
// ResourceCard that live pages render.
const props = defineProps<{ position: number }>()

getAnalyticsTracker().getChildContext({ position: computed(() => props.position) })
</script>

<template>
  <ResourceCard />
</template>
